module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    ref: "myChart",
    attrs: {
      "width": "100",
      "height": "30"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-573f4153","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elo-chart.vue
// module id = 229
// module chunks = 0